import { render, staticRenderFns } from "./Quality-Status.vue?vue&type=template&id=5dd3611a&lang=pug"
import script from "./Quality-Status.vue?vue&type=script&setup=true&lang=ts"
export * from "./Quality-Status.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports